
import {Component, Prop, Vue} from 'vue-property-decorator';
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
import ClientsCategoriesUpdateForm from "@/form/Settings/categories/clientsUpdate";

@Component({
    components: {FormGroup},
})
export default class ClientsUpdateForm extends Vue {
    @Prop() form!:  ClientsCategoriesUpdateForm;

    async created(): Promise<void> {
        console.log('creted');
    }
}
